import { ApprovalHistoryRecord } from "./approval-history-record";

export class GroupApprovalHistory {
  /**
   * The group associated with the item.
   */
  group: any;

  /**
   * The array of history records associated with the item.
   */
  historyRecords: Array<ApprovalHistoryRecord> = [];

  /**
   * The identifier of the item.
   */
  identifier: string;

  /**
   * Constructor
   * @param data
   */
  constructor(data?: any) {
    if (data) {
      this.group = data.group;
      this.historyRecords = data.historyRecords ? data.historyRecords : [new ApprovalHistoryRecord()];
      this.identifier = data.identifier;
    }
  }
}
